/*
 * @创建文件时间: 2019-12-29 19:32:58
 * @Auther: lfq
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-01-16 17:21:57
 * @联系Qq:1638245306
 * @文件介绍: 
 */
// 菜单 侧边栏
export default [
    // { path: '/index', title: '首页', icon: 'home' },
    // {
    //   title: '页面',
    //   icon: 'folder-o',
    //   children: [
    //     { path: '/page1', title: '页面 1' },
    //     { path: '/page2', title: '页面 2' },
    //     { path: '/page3', title: '页面 3' },
    // 	{ path: '/page4', title: '测试页面' }
    //   ]
    // }
]